
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import PieChart from "@/components/PieChart/index.vue";
import { Getter } from "vuex-class";
import { getPayWayStatistics, getPayWayStatisticsShop } from "@/api/shouyin";

// 付款方式
@Component({
  components: {
    CardContainer,
    PieChart,
  },
})
export class PaymentMethod extends Vue {
  @Prop({ default: () => ({}) }) params!: any;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;

  isInit = false;
  paramsPieChart: any = {
    type: "",
    data: [
      { name: "微信", value: "0", dataType: "money" },
      { name: "支付宝", value: "0", dataType: "money" },
      { name: "储值卡", value: "0", dataType: "money" },
      { name: "收款码", value: "0", dataType: "money" },
      { name: "现金", value: "0", dataType: "money" },
    ],
  };

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  async getData() {
    this.isInit = false;

    let res: any;
    if (this.isMultiStore) {
      const params = {
        queryType: this.params.orderType,
        queryTimeBegin: this.params.queryTimeBegin,
        queryTimeEnd: this.params.queryTimeEnd,
        storeList: this.multiStoreList.map((item) => {
          return { storeId: item };
        }),
      };
      res = await getPayWayStatisticsShop(params);
    } else {
      const params = {
        ...this.params,
      };
      delete params.timeType;
      res = await getPayWayStatistics(params);
    }

    this.paramsPieChart.data.forEach((dItem) => {
      const item = res.data.find((i) => i.payName === dItem.name);
      dItem.value = item?.orderMoney ?? "0";
    });
    this.isInit = true;
  }
}
export default PaymentMethod;
